import React, { Component } from 'react';
import config from "../../config";
import moment from "moment";
import { DISPATCH_ID } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import { ApiClient } from '../../libs/apiClient';
import { RouteDocDelivery, DocsLineRouteDelivery, SellerRouteEvent } from '../../components/NewOrder';
import $ from 'jquery';
import { BreadCumb, NavBar, DashboardDeliveries, CreateRoute, EventModal, UpdateDeliveryRoute, CreateRouteR2D2 } from "../../components/index";

let apiClient = ApiClient.getInstance();
const f = new Date();
const newDate = new Date(f.setMonth(f.getMonth() + (-1)))
const newFinalDate = new Date(f.setMonth(f.getMonth() + (1)))

class AdminDeliveries extends Component {
    constructor(props) {
        super(props)

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            itemsDashboard: JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard')),
            initDateSearch: moment(newDate).format('YYYY-MM-DD'),
            finalDateSearch: moment(newFinalDate).format('YYYY-MM-DD'),
            dateToSearch: moment(new Date()).format('YYYY-MM-DD'),
            view: 4,

            // CREATE ROUTE
            unAssignedDocs: [],
            drivers: [],
            vehicles: [],
            DeliveryRouteDoc: new RouteDocDelivery(),
            Waypoints: [],
            routes: [], // --
            InitEvents: [],
            DeliveryEventModel: new SellerRouteEvent(),
            actualDeliveries: [],
            EditableMode: false,
            infoWasUpdt: false,

            // R2D2
            ActualRoutes: []
        }
    }

    async componentDidMount() {
        this.FillMonthEvents();
        this.GetDeliveryRoutesByDate();
        await this.GetAllUnAssignedDocs();
        await this.GetAllDrivers();
        await this.GetAllAvailableVehicles();
        await this.GetAllRoutes()
    }

    recalculateRouteInfo = async () => {
        if (this.state.infoWasUpdt) {
            this.FillMonthEvents();
            this.GetDeliveryRoutesByDate();
            this.setState({
                infoWasUpdt: false,
            })
        }
    }

    //#region ######### GENERAL OPERATIONS #####################################################
    OnChangeView = async (value) => {
        const auxView = Number(value);
        await this.setState({
            view: auxView,
            Waypoints: [],
            initDateSearch: moment(newDate).format('YYYY-MM-DD'),
            finalDateSearch: moment(new Date()).format('YYYY-MM-DD'),
            DeliveryRouteDoc: new RouteDocDelivery(),

        });

        if (auxView === 2 || auxView === 4) {
            await this.GetEstimatedRoute();
        }

        // if (this.state.view === 1) {
        //     await this.FillMonthEvents();
        //     await this.GetDeliveryRoutesByDate();
        //     await this.GetAllUnAssignedDocs();
        // } else if (this.state.view === 2) {
        //     await this.GetAllUnAssignedDocs();
        //     await this.GetAllDrivers();
        //     await this.GetAllAvailableVehicles();//-
        // }
    }


    RefreshRouteDoc = async (DeliveryRouteDoc) => {
        await this.setState({ DeliveryRouteDoc });
    }

    CleanDeliveryDocModel = async () => {
        await this.setState({ DeliveryRouteDoc: new RouteDocDelivery(), });
    }

    ChangeFinalDate = async (value) => {
        this.setState({
            finalDateSearch: value
        })
    }

    ChangeInitialDate = async (value) => {
        this.setState({
            initDateSearch: value
        })
    }

    ChangeDateToSearch = async (value) => {
        this.setState({
            dateToSearch: value
        })
    }

    ChangeEditableMode = async () => {
        this.setState({
            EditableMode: !this.state.EditableMode
        })
    }

    //#endregion

    //#region ######### CATALOGS ###############################################################
    GetAllUnAssignedDocs = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { finalDateSearch, initDateSearch } = this.state;

        const data = {
            initDateSearch: initDateSearch,
            finalDateSearch: finalDateSearch
        };

        enableSpinner(true);
        const responseApi = await apiClient.getAllUnAssignedDocs(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }
        this.setState({ unAssignedDocs: responseApi.data.unAssignedDocs });
    }

    GetAllDrivers = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { drivers } = this.state
        if (drivers && drivers.length === 0) {
            enableSpinner(true);
            const responseApi = await apiClient.getDrivers();
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}` });
                return;
            }
            this.setState({ drivers: responseApi.data.drivers });

        }

    }

    GetAllAvailableVehicles = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { vehicles } = this.state

        if (vehicles && vehicles.length === 0) {
            enableSpinner(true);
            const responseApi = await apiClient.getVehicles();
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}` });
                return;
            }

            this.setState({ vehicles: responseApi.data.vehicles || [] });
        }

    }

    GetDeliveryRoutesByDate = async (dateToSearch) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let date = dateToSearch !== undefined ? dateToSearch : new Date();
        const data = {
            date
        }
        enableSpinner(true);
        const responseApi = await apiClient.getDeliveryRoutesByDate(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }
        this.setState({ actualDeliveries: responseApi.data || [] });
    }

    FillMonthEvents = async (Month) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const f = new Date();
        const month = Month !== undefined ? (Number(Month)) : (f.getMonth() + 1);
        const data = {
            month
        };
        enableSpinner(true);
        const responseApi = await apiClient.getDeliveryMountEvent(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        this.setState({
            InitEvents: responseApi.data || []
        });
    }

    GetDeliveryEventInfo = async (eventID) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            eventID
        }
        enableSpinner(true);
        let responseApi = await apiClient.getDeliveryEventInfo(data);

        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        const auxDocDelivery = await this.FillDeliveryEventInfo(responseApi.data);
        this.setState({
            DeliveryRouteDoc: auxDocDelivery
        })

        $('#EventModal').modal('show');

    }

    FillDeliveryEventInfo = async (infoDoc) => {
        let docDelivery = new RouteDocDelivery();

        if (infoDoc.headerDoc) {
            docDelivery.IdORDL = infoDoc.headerDoc.IdORDL;
            docDelivery.Code = infoDoc.headerDoc.Code;
            docDelivery.Name = infoDoc.headerDoc.Name;
            docDelivery.Description = infoDoc.headerDoc.Description;

            docDelivery.DocStatus = infoDoc.headerDoc.DocStatus;
            docDelivery.DocDate = moment(infoDoc.headerDoc.DocDate).format('YYYY-MM-DD');
            docDelivery.InitialDate = infoDoc.headerDoc.InitialDate;
            docDelivery.FinalDate = infoDoc.headerDoc.FinalDate;

            docDelivery.IsActive = infoDoc.headerDoc.IsActive === '1' ? true : false;
            docDelivery.NameDriver = infoDoc.headerDoc.driverName;
            docDelivery.driverPhone = infoDoc.headerDoc.PhoneNumber;
            docDelivery.email = infoDoc.headerDoc.Email ?? "";

            docDelivery.tipodeUnidad = infoDoc.headerDoc.TipodeUnidad ?? "";
            docDelivery.vehiclePlate = infoDoc.headerDoc.PlacaVM ?? "";

            docDelivery.IdVDRV = infoDoc.headerDoc.IdVDRV;
            docDelivery.IdVHCL = infoDoc.headerDoc.IdVHCL;

            if (this.state.drivers && this.state.drivers.length > 0) {
                const finded = this.state.drivers.findIndex((element) => Number(element.CodigoFiguraTransporte) === Number(infoDoc.headerDoc.IdVDRV))
                if (finded !== undefined) {
                    docDelivery.AuxIndexDriver = finded ?? ""
                }
            }

        }

        if (infoDoc.linesDoc && infoDoc.linesDoc.length > 0) {
            for (let index = 0; index < infoDoc.linesDoc.length; index++) {
                const lineDoc = infoDoc.linesDoc[index];
                let lineDocDelivery = new DocsLineRouteDelivery();

                lineDocDelivery.IdRDL1 = lineDoc.IdRDL1;
                lineDocDelivery.DocEntry = lineDoc.DocEntry;
                lineDocDelivery.DocNum = lineDoc.DocNum;

                lineDocDelivery.CardCode = lineDoc.CardCode;
                lineDocDelivery.CardName = lineDoc.CardName;
                lineDocDelivery.U_FMB_GPSLatS = lineDoc.U_FMB_GPSLatS;
                lineDocDelivery.U_FMB_GPSLonS = lineDoc.U_FMB_GPSLonS;

                lineDocDelivery.DocTotal = lineDoc.DocTotal;
                lineDocDelivery.Weight = lineDoc.Weight;

                lineDocDelivery.IdORDL = lineDoc.IdORDL;
                lineDocDelivery.DocStatus = lineDoc.DocStatus;
                lineDocDelivery.Comments = lineDoc.Comments || '';
                lineDocDelivery.NewDocEntry = lineDoc.NewDocEntry || '';

                lineDocDelivery.TypeDoc = lineDoc.TypeDoc || '';

                docDelivery.DocsLines.push(lineDocDelivery)
            }

        }


        return docDelivery
    }

    //#endregion

    //#region ######### CREATE ROUTE ###########################################################

    GetEstimatedRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc, _user } = this.state

        enableSpinner(true);
        const responseApi = await apiClient.GetEstimatedRoute();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        DeliveryRouteDoc.Code = `${_user?.Branch?.CodeBranchOffice ?? ''}RTDL${((Number(responseApi.data?.lastRow?.IdORDL ?? 1) + 1) ?? '')}`;
        this.RefreshRouteDoc(DeliveryRouteDoc)
    }

    AddToRoute = async (order) => {
        const { DeliveryRouteDoc, Waypoints } = this.state

        if (!this.ValidateIfIsAddedToRoute(order)) return;
        if (!this.ValidateCoordinates(order)) return;
        let docLine = new DocsLineRouteDelivery();
        let newRouteDoc = DeliveryRouteDoc;

        docLine.DocEntry = order.DocEntry;
        docLine.DocNum = order.DocNum;
        docLine.CardCode = order.CardCode;
        docLine.CardName = order.CardName;
        docLine.U_FMB_GPSLatS = order.U_FMB_GPSLatS;
        docLine.U_FMB_GPSLonS = order.U_FMB_GPSLonS;
        docLine.DocTotal = order.DocTotal;
        docLine.Weight = order.Weight;

        newRouteDoc.DocsLines.push(docLine);

        let newRouteOrdersPoints = Waypoints.slice();
        if (newRouteOrdersPoints.length > 0) {
            let ultimo = newRouteOrdersPoints.pop();
            newRouteOrdersPoints.push(
                { lng: parseFloat(order.U_FMB_GPSLonS), lat: parseFloat(order.U_FMB_GPSLatS) },  // <- We start here
            )
            newRouteOrdersPoints.push(ultimo);
        } else {
            let aux = { lng: parseFloat(order.U_FMB_GPSLonS), lat: parseFloat(order.U_FMB_GPSLatS) };
            newRouteOrdersPoints.push(aux);
            newRouteOrdersPoints.push(aux);
        }
        this.setState({
            DeliveryRouteDoc: newRouteDoc,
            Waypoints: newRouteOrdersPoints
        });
    }

    DeleteRoutePartner = (index) => {
        const { DeliveryRouteDoc, Waypoints } = this.state;
        let newRouteDoc = DeliveryRouteDoc;
        let newRouteOrderPoints = Waypoints.slice();
        newRouteDoc.DocsLines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
        newRouteOrderPoints.splice(index, 1)
        this.setState({ RouteDoc: newRouteDoc, Waypoints: newRouteOrderPoints });
    }


    SaveRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { DeliveryRouteDoc, _user } = this.state
        const USERID = _user.USERID;
        if (this.ValidateDeliveryRouteDoc()) {

            const data = {
                DeliveryRouteDoc,
                USERID
            }
            enableSpinner(true)
            const responseApi = await apiClient.createDeliveryRoute(data);
            enableSpinner(false)
            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: `${responseApi.message}` });
                return;
            }
            showAlert({ type: 'success', message: `${responseApi.message}` });

            this.setState({
                DeliveryRouteDoc: new RouteDocDelivery(),
                Waypoints: [],
                infoWasUpdt: true,
            })
            this.GetEstimatedRoute()
            this.GetAllUnAssignedDocs();
            this.GetDeliveryRoutesByDate()

        }
    }


    ValidateCoordinates = (order) => {
        const { notificationReducer: { showAlert } } = this.props
        if (order.U_FMB_GPSLatS === undefined || order.U_FMB_GPSLatS === '' || order.U_FMB_GPSLatS === null || order.U_FMB_GPSLonS === undefined || order.U_FMB_GPSLonS === '' || order.U_FMB_GPSLonS === null) {
            showAlert({ type: 'error', message: `IMPOSIBLE AGREGAR, LA DIRECCIÓN DE ENVIÓ DE LA ORDEN NO CUENTA CON COORDENADAS` });
            return false
        }
        return true;
    }

    ValidateIfIsAddedToRoute = (document) => {
        const { notificationReducer: { showAlert } } = this.props
        const { DeliveryRouteDoc } = this.state
        for (let i = 0; i < DeliveryRouteDoc.DocsLines.length; i++) {
            const doc = DeliveryRouteDoc.DocsLines[i];
            if (doc.DocEntry === document.DocEntry) {
                showAlert({ type: 'info', message: `YA HAS AGREGADO ESTE DOCUMENTO A LA RUTA` });
                return false;
            }
        }
        return true;
    }

    ValidateDeliveryRouteDoc = () => {
        const { notificationReducer: { showAlert } } = this.props
        const { DeliveryRouteDoc } = this.state

        if (DeliveryRouteDoc.DocsLines.length === 0) {
            showAlert({ type: 'error', message: `NO SE PUEDE AGREGAR UNA RUTA SIN ORDENES` });
            return false;
        }
        // if (DeliveryRouteDoc.DocsLines.length === 1) {
        //     showAlert({ type: 'error', message: `SE NECESITA MAS DE 1 DOCUMENTO PARA QUE SEA UNA RUTA`, timeOut: 5000 });
        //     return false;
        // }
        if (DeliveryRouteDoc.Code === '') {
            showAlert({ type: 'error', message: `EL CAMPO CÓDIGO ESTA VACIÓ` });
            return false;
        }
        if (DeliveryRouteDoc.Name === '') {
            showAlert({ type: 'error', message: `EL CAMPO NOMBRE ESTA VACIÓ` });
            return false;
        }
        if (DeliveryRouteDoc.IdVDRV === '') {
            showAlert({ type: 'error', message: `AUN NO HAS ASIGNADO UN CHOFER PARA ESTE DOCUMENTO` });
            return false;
        }
        if (DeliveryRouteDoc.CodigoAutotransporte === '') {
            showAlert({ type: 'error', message: `AUN NO HAS ASIGNADO UN TRANSPORTE PARA ESTE DOCUMENTO` });
            return false;
        }
        return true;
    }

    DeleteDeliveryRouteEvent = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { DeliveryRouteDoc } = this.state
        const data = {
            IdORDL: DeliveryRouteDoc.IdORDL,
        }
        enableSpinner(true)
        let responseApi = await apiClient.deleteDeliveryRouteEvent(data);
        enableSpinner(false)

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: 'success', message: `${responseApi.message}` });

        this.setState({
            DeliveryRouteDoc: new RouteDocDelivery()
        })
        await this.FillMonthEvents();
        await this.GetDeliveryRoutesByDate();

    }
    //#endregion

    //#region ######### UPDATE ROUTE ###########################################################
    GetInfoRouteById = async (eventID) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            eventID
        }

        enableSpinner(true);
        const responseApi = await apiClient.getDeliveryEventInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        const auxDocDelivery = await this.FillDeliveryEventInfo(responseApi.data);

        this.setState({
            DeliveryRouteDoc: auxDocDelivery
        })
    }

    GetDeliveryRoutePoints = async (routeID) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const data = {
            routeID
        }
        enableSpinner(true)
        const responseApi = await apiClient.getDeliveryRoutePoints(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }

        let points = [];
        for (let i = 0; i < responseApi.data.length; i++) {
            const element = responseApi.data[i];
            points.push({ lng: element.U_FMB_GPSLonS, lat: element.U_FMB_GPSLatS });
        }

        points.push(points[0]);
        this.setState({
            Waypoints: points || []
        })

    }

    DeleteDocFromDeliveryRouteDoc = async (index) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc, Waypoints } = this.state;
        if (DeliveryRouteDoc.DocsLines[index].DocStatus === 'C') {
            showAlert({ type: 'info', message: `Este documento ya fue atendido, no se puede eliminar. `, timeOut: 5000 });
            return
        }
        const wasDelete = await this.UnlinkDocument(DeliveryRouteDoc.DocsLines[index]);
        if (wasDelete) {
            let newRouteDoc = DeliveryRouteDoc;
            let newWaypoints = Waypoints.slice();
            newRouteDoc.DocsLines.splice(index, 1); // 1 es la cantidad de elemento a eliminar
            newWaypoints.splice(index, 1)

            this.setState({
                RouteDoc: newRouteDoc,
                Waypoints: newWaypoints,
            });
            await this.GetAllUnAssignedDocs();
        }
    }

    UnlinkDocument = async (modelLineDoc) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            modelLineDoc
        }
        enableSpinner(true)
        let responseApi = await apiClient.unlinkDocument(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return false;
        }
        return true;

    }

    SaveUpdateDeliveryRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc } = this.state;
        const data = {
            DeliveryRouteDoc
        }
        enableSpinner(true)
        let responseApi = await apiClient.updateDeliveryRoute(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        showAlert({ type: 'success', message: `${responseApi.message}`, timeOut: 5000 });
        await this.setState({
            DeliveryRouteDoc: new RouteDocDelivery(),
            EditableMode: false,
            Waypoints: [],
            infoWasUpdt: true,
        })
        await this.GetAllUnAssignedDocs();
        await this.GetDeliveryRoutesByDate()
    }

    DeleteDeliveryRoute = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { DeliveryRouteDoc } = this.state
        const data = {
            DeliveryRouteDoc
        }
        showAlert({ type: 'info', message: `Solo se desvincularon los documentos no atendidos`, timeOut: 5000 });
        enableSpinner(true)
        let responseApi = await apiClient.deleteDeliveryRoute(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 5000 });
            return
        }
        this.setState({
            DeliveryRouteDoc: new RouteDocDelivery(),
            EditableMode: false,
            Waypoints: [],
            infoWasUpdt: true,
        })

        await this.GetAllUnAssignedDocs();
        await this.GetDeliveryRoutesByDate();

    }
    //#endregion

    //#region ######### DASHBOARD ROUTE ########################################################

    //#endregion

    //#region ######### CALENDAR SPECIAL FUNCTIONS #############################################
    handleDateSelect = async (selectInfo) => {
        await this.SetEventsDates(selectInfo);
        $('#generalModal').modal('show');
    }

    SetEventsDates = (selectInfo) => {
        // const { EventModel } = this.state
        // EventModel.DateStart = selectInfo.startStr;
        // EventModel.DateEnd = selectInfo.endStr;
        // this.setState({
        //     EventModel,
        //     calendarInfo: selectInfo.view.calendar
        // });
    }

    handleEventClick = (clickInfo) => {
        this.GetDeliveryEventInfo(clickInfo.event.id)
    }

    renderEventContent = (eventInfo) => {
        return (
            <>
                <b>{eventInfo.timeText}</b>
                <i>{eventInfo.event.title}</i>
            </>
        )
    }
    //#endregion


    //#region ######### CREATE ROUTE BY R2D2 #############################################
    GetAllRoutes = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.GetAllRoutes();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        this.setState({ ActualRoutes: responseApi.data });


    }

    GenerateRouteDocByIA = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.GenerateRouteDocByIA();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return;
        }

        const newRouteModel = await this.FillRouteDocByR2D2(responseApi.data);
        this.setState({
            DeliveryRouteDoc: newRouteModel
        });

    }

    FillRouteDocByR2D2 = (infoDoc) => {
        let docDelivery = new RouteDocDelivery();

        if (infoDoc.Lines && infoDoc.Lines.length > 0) {
            for (let index = 0; index < infoDoc.Lines.length; index++) {
                const suggestLine = infoDoc.Lines[index];
                let lineDocDelivery = new DocsLineRouteDelivery();

                lineDocDelivery.IdRDL1 = suggestLine?.IdRDL1 ?? -1;
                lineDocDelivery.DocEntry = suggestLine.DocEntry ?? -1;
                lineDocDelivery.DocNum = suggestLine.DocNum ?? -1;

                lineDocDelivery.CardCode = suggestLine.CardCode;
                lineDocDelivery.CardName = suggestLine.CardName;
                lineDocDelivery.U_FMB_GPSLatS = suggestLine.U_FMB_GPSLatS;
                lineDocDelivery.U_FMB_GPSLonS = suggestLine.U_FMB_GPSLonS;

                lineDocDelivery.DocTotal = suggestLine.LineTotal ?? 0.0;
                lineDocDelivery.Weight = suggestLine.Weight ?? -1;

                lineDocDelivery.IdORDL = suggestLine.IdORDL ?? -1;
                // lineDocDelivery.DocStatus = suggestLine.DocStatus; 
                // lineDocDelivery.Comments = suggestLine.Comments || '';
                // lineDocDelivery.NewDocEntry = suggestLine.NewDocEntry || '';

                lineDocDelivery.ObjType = suggestLine.ObjType ?? -1;
                lineDocDelivery.NumAtCard = suggestLine.NumAtCard ?? "";
                lineDocDelivery.ItemName = suggestLine.Dscription ?? "";
                lineDocDelivery.Quantity = suggestLine.Quantity ?? "";
                lineDocDelivery.LineTotal = suggestLine.LineTotal ?? 0.0;
                lineDocDelivery.TotalWeightLine = suggestLine?.weight ?? 0.0;
                docDelivery.DocsLines.push(lineDocDelivery)
            }

        }
        return docDelivery
    }

    //#endregion

    render() {
        const { notificationReducer: { showAlert } } = this.props
        const {
            itemsDashboard,
            view,
            unAssignedDocs,
            drivers,
            DeliveryRouteDoc,
            Waypoints,
            finalDateSearch,
            initDateSearch,
            vehicles,
            InitEvents,
            actualDeliveries,
            dateToSearch,
            EditableMode,
            ActualRoutes
        } = this.state

        const CalendarFunctions = {
            handleDateSelect: this.handleDateSelect,
            renderEventContent: this.renderEventContent,
            handleEventClick: this.handleEventClick
        }

        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} />

                <BreadCumb subitem1={'ADMINISTRADOR DE ENTREGAS'} url1={'#'} />
                <div style={{ marginLeft: "4.5rem" }}>
                    <h2 className="md-display-1">
                        <label id="linkOrdProv" className="text-muted">
                            &nbsp;ADMINISTRADOR DE ENTREGAS
                        </label>
                    </h2>
                </div>
                <div style={{ marginLeft: "4rem" }}>
                    {/* <select name="select"
                        onChange={(event) => this.OnChangeView(event.target.value)}
                        value={view || ''}
                    >
                        <option value={1} >Dashboard</option>
                        <option value={2} >Crear ruta</option>
                        <option value={3} >Editar ruta</option>
                    </select> */}

                    <ul className="nav nav-tabs md-tabs" id="myTabMD" role="tablist" style={{ position: "relative", zIndex: 1, padding: "0.7rem", marginRight: "1rem", marginBottom: "-20px", marginLeft: "1rem", backgroundColor: "#e9ecef", border: 0, borderRadius: "0.25rem" }}>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => { this.OnChangeView(1); this.recalculateRouteInfo() }}>
                            <span className="nav-link " id="week-tab-md" data-toggle="tab" href="#week-md" role="tab" aria-controls="week-md" aria-selected="false" style={{ color: "gray" }}>General</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.OnChangeView(2)}>
                            <span className="nav-link " id="mont-tab-md" data-toggle="tab" href="#mont-md" role="tab" aria-controls="mont-md" aria-selected="false" style={{ color: "gray" }}>Crear ruta</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.OnChangeView(3)}>
                            <span className="nav-link " id="afterM-tab-md" data-toggle="tab" href="#afterM-md" role="tab" aria-controls="afterM-md" aria-selected="false" style={{ color: "gray" }}>Editar ruta</span>
                        </li>

                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.OnChangeView(4)}>
                            <span className="nav-link show active" id="afterM-tab-md" data-toggle="tab" href="#afterM-md" role="tab" aria-controls="afterM-md" aria-selected="false" style={{ color: "gray" }}>Crear ruta R2D2</span>
                        </li>
                        {/* <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(4)}>
                            <span className="nav-link " id="afterY-tab-md" data-toggle="tab" href="#afterY-md" role="tab" aria-controls="afterY-md" aria-selected="false" style={{ color: "gray" }}>Eliminar rutas</span>
                        </li>
                        <li className="nav-item waves-effect waves-light d-inline" onClick={() => this.ChangeView(5)}>
                            <span className="nav-link " id="afterX-tab-md" data-toggle="tab" href="#afterX-md" role="tab" aria-controls="afterX-tab-md" aria-selected="false" style={{ color: "gray" }}>Programar rutas</span>
                        </li> */}
                    </ul>

                    {Number(view) === 1 &&
                        <DashboardDeliveries
                            Waypoints={Waypoints}
                            ActualDeliveries={actualDeliveries}
                            InitEvents={InitEvents}
                            CalendarFunctions={CalendarFunctions}
                        />
                    }
                    {Number(view) === 2 &&
                        <CreateRoute
                            InitDateSearch={initDateSearch}
                            FinalDateSearch={finalDateSearch}
                            UnAssignedDocs={unAssignedDocs}
                            Drivers={drivers}
                            Vehicles={vehicles}
                            RouteDoc={DeliveryRouteDoc}
                            Waypoints={Waypoints}
                            showAlert={showAlert}
                            AddToRoute={this.AddToRoute}
                            RefreshRouteDoc={this.RefreshRouteDoc}
                            SaveRoute={this.SaveRoute}
                            DeleteRoutePartner={this.DeleteRoutePartner}
                            ChangeInitialDate={this.ChangeInitialDate}
                            ChangeFinalDate={this.ChangeFinalDate}
                            GetAllUnAssignedDocs={this.GetAllUnAssignedDocs}
                        />
                    }
                    {Number(view) === 3 &&

                        <UpdateDeliveryRoute
                            showAlert={showAlert}
                            RouteDoc={DeliveryRouteDoc}
                            Waypoints={Waypoints}
                            FinalDateSearch={finalDateSearch}
                            ActualDeliveries={actualDeliveries}
                            InitDateSearch={initDateSearch}
                            UnAssignedDocs={unAssignedDocs}
                            dateToSearch={dateToSearch}
                            EditableMode={EditableMode}
                            Drivers={drivers}
                            Vehicles={vehicles}
                            ChangeDateToSearch={this.ChangeDateToSearch}
                            ChangeFinalDate={this.ChangeFinalDate}
                            ChangeInitialDate={this.ChangeInitialDate}
                            GetDeliveryRoutesByDate={this.GetDeliveryRoutesByDate}
                            GetInfoRouteById={this.GetInfoRouteById}
                            GetDeliveryRoutePoints={this.GetDeliveryRoutePoints}
                            GetAllUnAssignedDocs={this.GetAllUnAssignedDocs}
                            AddToRoute={this.AddToRoute}
                            DeleteDocFromDeliveryRouteDoc={this.DeleteDocFromDeliveryRouteDoc}
                            ChangeEditableMode={this.ChangeEditableMode}
                            RefreshRouteDoc={this.RefreshRouteDoc}
                            DeleteDeliveryRoute={this.DeleteDeliveryRoute}
                            SaveUpdateDeliveryRoute={this.SaveUpdateDeliveryRoute}
                        />
                    }
                    {Number(view) === 4 &&

                        <CreateRouteR2D2
                            showAlert={showAlert}
                            RouteDoc={DeliveryRouteDoc}
                            ActualRoutes={ActualRoutes}
                            RefreshRouteDoc={this.RefreshRouteDoc}
                            Drivers={drivers}
                            Vehicles={vehicles}
                            GenerateRouteDocByIA={this.GenerateRouteDocByIA}


                            Waypoints={Waypoints}
                            FinalDateSearch={finalDateSearch}
                            ActualDeliveries={actualDeliveries}
                            InitDateSearch={initDateSearch}
                            UnAssignedDocs={unAssignedDocs}
                            dateToSearch={dateToSearch}
                            EditableMode={EditableMode}

                            ChangeDateToSearch={this.ChangeDateToSearch}
                            ChangeFinalDate={this.ChangeFinalDate}
                            ChangeInitialDate={this.ChangeInitialDate}
                            GetDeliveryRoutesByDate={this.GetDeliveryRoutesByDate}
                            GetInfoRouteById={this.GetInfoRouteById}
                            GetDeliveryRoutePoints={this.GetDeliveryRoutePoints}
                            GetAllUnAssignedDocs={this.GetAllUnAssignedDocs}
                            AddToRoute={this.AddToRoute}
                            DeleteDocFromDeliveryRouteDoc={this.DeleteDocFromDeliveryRouteDoc}
                            ChangeEditableMode={this.ChangeEditableMode}

                            DeleteDeliveryRoute={this.DeleteDeliveryRoute}
                            SaveUpdateDeliveryRoute={this.SaveUpdateDeliveryRoute}
                        />
                    }

                </div>
                <EventModal
                    title={this.TitleEventModal()}
                    body={this.BodyEventModal()}
                    footer={this.FooterEventModal()}
                    CloseActions={this.CleanDeliveryDocModel}

                />
            </div>
        )
    }

    //#region ######### -EVENT MODAL ############################################################
    TitleEventModal = () => {
        return (
            <div>
                <h4 className="modal-title" style={{ color: "white", fontWeight: "bold" }} id="exampleModalLabel">DATOS DE LA ENTREGA</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style={{ color: "white" }}>&times;</span>
                </button>
            </div>
        );
    }

    BodyEventModal = () => {
        const { DeliveryRouteDoc } = this.state

        return (
            <div>
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className='row'>
                            <div className="col-lg-12 mb-4 order-0">
                                <div className="card">
                                    <div className="d-flex align-items-end row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <h5 className="card-title text-primary">Entrega </h5>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <label for="exampleInputEmail1">Identificador nombre</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            placeholder="Identificador nombre"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.Name !== '' ? DeliveryRouteDoc.Name : ''}

                                                        />
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <label for="exampleInputEmail1">Código del evento</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            placeholder="Código del evento"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.Code !== '' ? DeliveryRouteDoc.Code : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <label for="exampleInputEmail1">Chofer</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            placeholder="Chofer"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.NameDriver !== '' ? DeliveryRouteDoc.NameDriver : ''}
                                                        />
                                                    </div>

                                                    <div className='col-sm-6'>
                                                        <label for="exampleInputEmail1">Vehículo</label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.vehicleBrand !== '' ? DeliveryRouteDoc.vehicleBrand : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>

                                                    <div className='col-sm-6'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Contacto chofer </label>
                                                            <input
                                                                disabled={true}
                                                                type="email"
                                                                className="form-control"
                                                                id="exampleInputEmail1"
                                                                value={DeliveryRouteDoc && DeliveryRouteDoc.driverPhone !== '' ? DeliveryRouteDoc.driverPhone : ''}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-sm-6'>
                                                        <label for="exampleInputEmail1">Vehículo placa </label>
                                                        <input
                                                            disabled={true}
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.vehiclePlate !== '' ? DeliveryRouteDoc.vehiclePlate : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <h4 className="pr-2">Inicio: </h4>
                                                        <input
                                                            disabled={true}
                                                            id="fechaInicio"
                                                            type="date"
                                                            className="form-control col-md-6"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.InitialDate !== '' ? DeliveryRouteDoc.InitialDate : ''}

                                                        />

                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <h4 className="pr-2">Final: </h4>
                                                        <input
                                                            disabled={true}
                                                            id="fechaInicio"
                                                            type="date"
                                                            className="form-control col-md-6"
                                                            value={DeliveryRouteDoc && DeliveryRouteDoc.FinalDate !== '' ? DeliveryRouteDoc.FinalDate : ''}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 order-2 mb-4">
                                <div className="card h-100">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <h5 className="card-title m-0 me-2">CLIENTES VISITADOS</h5>
                                        <div className="dropdown">
                                        </div>
                                    </div>
                                    <div className="card-body " >
                                        <table id="noSalesReportTable" className="table table-striped scrolltable" style={{ fontSize: "1.2rem" }}>
                                            <thead style={{ textAlign: "-webkit-center" }}>
                                                <tr style={{ backgroundColor: "#0071bc", color: "white", fontSize: "1rem" }}>
                                                    <th scope="col-lg-auto"></th>
                                                    <th scope="col-lg-auto">CLIENTE</th>
                                                    <th scope="col-lg-auto">ESTATUS DE LA VISITA</th>
                                                    <th scope="col-lg-auto">ORDEN NO. DOC</th>
                                                    <th scope="col-lg-auto">ENTREGA NO. DOC</th>
                                                    <th scope="col-lg-auto">ID REPORTE DE NO ENTREGA</th>

                                                    <th scope="col-lg-auto">FECHA Y HORA DE LLEGADA</th>
                                                    <th scope="col-lg-auto">FECHA Y HORA DE SALIDA</th>
                                                    <th scope="col-lg-auto">TIEMPO DE VISITA.</th>

                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "-webkit-center" }} className='scrollCardBP'>

                                                {DeliveryRouteDoc.DocsLines && DeliveryRouteDoc.DocsLines.length > 0 && DeliveryRouteDoc.DocsLines.map((delivery, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>
                                                                {delivery.DocStatus === 'O' ?
                                                                    <i className="fa fa-clock-o" style={{ fontSize: 'x-large' }} aria-hidden="true"></i>
                                                                    :
                                                                    <i className="fa fa-check-circle-o" style={{ fontSize: 'x-large', color: 'green' }} aria-hidden="true"></i>
                                                                }

                                                            </th>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.CardCode}</th>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.DocStatus === 'O' ? 'NO ENTREGADO' : 'ENTREGADO'}</td>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.DocNum === '' ? '-' : delivery.DocNum}</th>
                                                            <th scope="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.NewDocEntry === '' ? '-' : delivery.NewDocEntry}</th>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.IdReport === 0 ? '-' : delivery.IdReport}</td>

                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.InitVisitDateTime === '' ? '-' : delivery.InitVisitDateTime}</td>
                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{delivery.FinalVisitDateTime === '' ? '-' : delivery.FinalVisitDateTime} </td>

                                                            <td className="col-lg-auto" style={{ fontSize: "1rem", width: '250px' }}>{'1900-01-01T00:00:00.000Z'}</td>

                                                        </tr>)
                                                })}


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>


                </div>

            </div>
        );
    }

    FooterEventModal = () => {
        return (
            <div className="d-flex flex-row-reverse ">
                <button type="button" className="btn btn-info ml-2" data-dismiss="modal" onClick={() => this.CleanDeliveryDocModel()}>Cerrar</button>
                {/* <button type="button" class="btn btn-danger" data-dismiss="modal" onClick={() => this.DeleteDeliveryRouteEvent()} >Eliminar evento</button> */}
            </div>

        );
    }
    //#endregion


}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminDeliveries);